import React, { Component } from 'react';
import './TrainerView.css';
import Button from '../../components/Button/Button.js'


export default class TrainerView extends Component {

constructor(props, context) {
    super(props, context);

    this.state={
      apiUrl: '',
      articles: [],
      pathWay: '',
      currentModule: 0,
      activeArticle: true,
      showLoader: false,
      showPrev: true,
      showNext: true,
      moduleName: '',
      navState: 'closed',
      title: '',
      body: '',
      nextButtonState: '',
      prevButtonState: '',
      errorState: false
    }

     this.getZendeskArticle = this.getZendeskArticle.bind(this)
     this.handleKeyDown = this.handleKeyDown.bind(this)

  }

  componentDidMount(){

      if(this.props.moduleID){

        this.getmoduleData(this.props.moduleID);
        // ZENDESK
        // const script = document.createElement("script");
        // script.setAttribute("id", "ze-snippet");
        // script.src = "https://static.zdassets.com/ekr/snippet.js?key=b49baac9-9f26-42d1-8d4e-f3142ff18a38";
        // script.async = true;
        // script.onload = () => this.scriptLoaded();
        // document.body.appendChild(script);
        //

      }else{
        console.log("No module ID");
      }
  }


  /*---------------------------------------
      LOADED SCRIPT
  -----------------------------------------*/
  scriptLoaded(){
    console.log('Loaded Zendesk');

  }
  /*---------------------------------------
      GET MODULE DATA
  -----------------------------------------*/
  getmoduleData(id){

    let url;

    if(window.location.hostname === 'localhost'){
       url = 'http://127.0.0.1:3030/getModule'
    }else{
      url = 'http://trainer.activepipe.com:3030/getModule'
    }

    fetch(url, {
      method: 'POST',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id
      })
    })
    .then((response) => response.json())
    .then((responseJson) =>
    {

        // console.log(responseJson);

        let totalTime = 0;
        for (let i in JSON.parse(responseJson[0].path)){
            totalTime += parseInt(JSON.parse(responseJson[0].path)[i].readTime, 10);
        }

        this.setState({
          pathWay: JSON.parse(responseJson[0].path),
          articles: JSON.parse(responseJson[0].path),
          moduleName: responseJson[0].name,
          readTime: totalTime,
          errorState: false
        })

        window.document.title = "ActivePipe - " + responseJson[0].name
        document.getElementsByClassName("articleLink")[0].classList.add('activeArticle')

        // LOAD FIRST ARTICLE
        this.jumpToArticle(0);

    }).catch((error) => {
        console.log("Error");
        // alert("There is nothing here......")
         this.setState({
          errorState: true
        })
        console.error(error);
    });

}

  /*---------------------------------------
      GET ZENDESK ARTICLE
  -----------------------------------------*/
  getZendeskArticle(id){

    const myTimer = setTimeout(()=>{
      this.setState({
        showLoader: true,
        errorState: false
      })
    },500)

    fetch('https://activepipesupport.zendesk.com/api/v2/help_center/articles/' + id, {
      method: 'GET'
    })
    .then((response) => response.json())
      .then((responseJson) =>
      {

        clearTimeout(myTimer)

        this.setState({
          title: responseJson.article.name,
          body: responseJson.article.body,
          showLoader: false,
          errorState: false,
          headerNumber: this.state.currentModule+1
        })

        window.scrollTo(0,0);


      })
      .catch((error) => {
        console.log("Error: Can't Find Article or Zendesk Down")
        console.error(error)
        clearTimeout(myTimer)
        // document.getElementsByClassName('articleBody').scrollTop = 0;
        window.scrollTo(0,0);
          this.setState({
            title: '',
            body: '',
            headerNumber: '',
            showLoader: false,
            errorState: true
        })
      });

  }


  /*---------------------------------------
      NAV
  -----------------------------------------*/
  hideShowNav(){


  }

  /*---------------------------------------
      KEY PRESS
  -----------------------------------------*/
   handleKeyDown(e) {

     if(e.keyCode === 39){
      this.nextArticle()
     }
     else if(e.keyCode === 37){
      this.previousArticle()
     }
  }
  /*---------------------------------------
      MODULE NAVIGATION
  -----------------------------------------*/
  nextArticle(){

    console.log("Next Article");

    if(this.state.currentModule < this.state.pathWay.length-1){

      this.setState({
        currentModule: this.state.currentModule+1
      })
      this.jumpToArticle(this.state.currentModule+1)
    }

  }

  previousArticle(){

    console.log('Previous Article');

     if(this.state.currentModule > 0){
      this.setState({currentModule: this.state.currentModule-1})
      this.jumpToArticle(this.state.currentModule-1)
    }

  }

  firstArticle(){

    console.log("Go Home");
    this.setState({
      currentModule: 0
    })
    this.jumpToArticle(0)
  }


  jumpToArticle(index){

    this.setState({
      currentModule: index
    })

    // REMOVE AND ADD CLASS
    const x = document.getElementsByClassName("activeArticle");
    while (x[0]) {
      x[0].classList.remove('activeArticle')
    }
    document.getElementsByClassName("articleLink")[index].classList.add('activeArticle')

    // BUTTON DISABLED/ABLED
    if(index >= this.state.pathWay.length-1){
      this.setState({nextButtonState: 'disabled'})

    }else{
      this.setState({nextButtonState: ''})
    }
    if(index === 0){
      this.setState({prevButtonState: 'disabled'})
    }else{
      this.setState({prevButtonState: ''})
    }

    this.setState({
        navState: 'closed'
    })

    // GO GET THE ARTICLE
    this.getZendeskArticle(this.state.pathWay[index].id);

  }

  /*---------------------------------------
      MOBILENAV
  -----------------------------------------*/
  showMobileNav(){
    console.log("Sho nav");
    if(this.state.navState === 'open'){
      this.setState({
        navState: 'closed'
      })
    }else{
      this.setState({
        navState: 'open'
      })
    }

  }

  /*---------------------------------------
      RENDER
  -----------------------------------------*/
  render() {

    return (
      <div className="centered" tabIndex="0" onKeyDown={this.handleKeyDown }>

        <div className={"articleNavigation"}>
          <div className={"trainerHeader"}>
              <div className={'mobileNav'} onClick={(e)=>this.showMobileNav()}><img src="../assets/images/icons/list.svg" alt="Menu"/></div>
              {this.state.moduleName}
              <div className={"loaderBar  " + (this.state.showLoader ? 'loaderBarAnimate' : '')}></div>
          </div>
          <div className={"articleLinWrapper " + (this.state.navState === 'open' ? 'showNav' : 'hideNav')}>

            {
              this.state.articles.map((article, index) =>{
                return(
                <div
                key={index}
                onClick={(e) => this.jumpToArticle(index)}
                className={"articleLink"}
                >
                <div className={"articleName"}>
                  <div className={"articelNumber"}>{index+1} </div>
                  <div>{article.name}
                  {/* {article.readTime ? <span>({article.readTime}min)</span> :null } */}
                  </div>
                </div>

                </div>
                )
              })
            }
            </div>
            </div>

        {/* MAIN CONTENT */}
        <div className={"articleBody"}>

          <div className={"mainContent " + (this.state.errorState ? 'error' : '')} >
          <h1>
          { this.state.headerNumber ?
            <span className={'headerNumber'}>{this.state.headerNumber}</span>
            : null
          }
          {this.state.title}</h1>
          <div dangerouslySetInnerHTML={{__html: this.state.body}}></div>
          </div>

        </div>



        {/* BOTTOM NAVIGATION */}
         <div className={"trainerNavigation"}>
         <div className={"inner"}>
          <div className={"left"}>
            <img src="../assets/images/logos/activepipe_landscape_reversed.svg" alt="ActivePipe"/>
          </div>
          <div className={"right"}>
           <span className={"steps"}>{this.state.currentModule+1}/{this.state.pathWay.length}</span>
           {/* <span> { this.state.readTime ? <span> Read Time: {this.state.readTime}mins</span>:null}</span> */}

            { this.state.showPrev ? <Button clickAction={()=>this.previousArticle()} text="" altText= "Previous" imagePath="../assets/images/icons/arrow_left.svg" buttonColor="red" size="small" disabled={this.state.prevButtonState}/> : null }
            { this.state.showNext ? <Button clickAction={()=>this.nextArticle()} text="" altText="Next" imagePath="../assets/images/icons/arrow_right.svg" buttonColor="red" size="small" disabled={this.state.nextButtonState}/> : null }
            </div>
        </div>
        </div>




      </div>


    );
  }

}


// WEBPACK FOOTER //
// ./src/views/TrainerView/TrainerView.js